import { useEffect } from 'react';
import './styles/App.scss';
import Layout from './components/Layout';
import Form from './components/Form';
import Results from './components/Results';
import { useCallback, useState } from 'react';
import axios from 'axios';
import qs from 'query-string';
import Papa from 'papaparse';
import {GoogleMap, useLoadScript, Marker} from '@react-google-maps/api';

const API_URL = process.env.REACT_APP_API_URL;
console.log("API_URL: " + API_URL)

function App() {
  const [formState, setFormState] = useState({
    address: "",
    asked_date: "",
  });
  const [results, setResults] = useState(null);
  const [userLat, setUserLat] = useState(null);
  const [userLng, setUserLng] = useState(null);

  function geolocaliser(setFormState) {
  if (!navigator.geolocation) {
    alert("La géolocalisation n'est pas supportée par ce navigateur.");
    return;
  }

  navigator.geolocation.getCurrentPosition(success, error);

  function success(position) {
    const { latitude, longitude } = position.coords;
    setUserLat(latitude);
    setUserLng(longitude);

    axios.get("https://nominatim.openstreetmap.org/reverse", {
      params: {
        format: "json",
        lat: latitude,
        lon: longitude
      }
    })
    .then(response => {
      const adresse = response.data.display_name || `${latitude}, ${longitude}`;
      console.log("Adresse géo: " + adresse)
      setFormState("address", adresse);
    })
    .catch(() => {
      setFormState("address", `${latitude}, ${longitude}`);
    });
  }

  function error(err) {
    console.error("Erreur de géolocalisation navigateur :", err);
    alert("Impossible de récupérer votre position.");
  }
}

  const handleChangeFormState = useCallback((name, value) => {
    let formStateOld = { ...formState };
    formStateOld[name] = value;

    setFormState(formStateOld);
   }, [formState]);

  const handleSend = useCallback(() => {
    setResults(null);
    console.log(formState)
    const parameters = qs.stringify({
      address: formState.address,
      asked_date: formState.asked_date 
    });

    axios.get(`${API_URL}?${parameters}`)
      .then(resp => {
        setResults(resp.data);
      })
      .catch(error => {
        window.alert('Erreur lors de l\'éxécution de la fonction :\n\n' + error.message);
      });
  }, [formState]);

  return (
    <div className="App">
      <Layout>
        <div>
          <Form formState={formState} setFormState={handleChangeFormState} geolocaliser={geolocaliser} handleSend={handleSend}  />
          <Results results={results} userLat={userLat} userLng={userLng}/>
        </div>
      </Layout>
    </div>
  );
}

export default App;
